import {
  init,
  setUser as sentrySetUser,
  captureException,
  captureEvent,
} from '@sentry/capacitor';
import type { BrowserOptions } from '@sentry/react';
import { initialiseSentry as initWeb } from './web';
export function initialiseSentry(config: Parameters<typeof init>[0]) {
  init<Parameters<typeof init>[0]>(config, (options) => {
    /**
     *
     * Coercing here because of type mismatch between
     * @sentry/capacitor (0.5.0) and @sentry/react (6.19.4)
     * version of @sentry/browser (6.17 vs 6.19)
     *
     * */
    initWeb(options as BrowserOptions);
  });
}

export function setUser(user: Parameters<typeof sentrySetUser>[0]) {
  sentrySetUser(user);
}

export function logError(error: unknown) {
  captureException(error);
}

export const logEvent: typeof captureEvent = (event, hint) => {
  return captureEvent(event, hint);
};
